<template>
	<div class="ks-search-bar">
		<k-text-field
			placeholder="Search"
			prepend-icon="search" 
			v-model="data_search" 
			ref="search_field" 
			autofocus 
			clearable
			hide-details
			style="margin-left: 5px;"
		></k-text-field>
			<div class="ks-floating-menu ks-search-bar-results" v-if="data_search && $slots.default">
				<slot></slot>
			</div>
	</div>
</template>

<script>
export default {
	props: ["value"],
	watch: {
		"value": function(newValue) {
			this.data_search = newValue;
		},
		'data_search': function(newValue) {
			this.$emit("input", newValue);
		}
	},
	data () {
		return {
			data_search: this.value,
			show_results: true
		}
	},
	mounted () {
		this.$refs.search_field.focus();
	},
	methods: {
	}
}
</script>
<style scoped>
.ks-search-bar {
	margin: 0;
	width: 100% !important;
	padding: 0 !important;
	position: relative;
}
.ks-search-bar .ks-search-bar-results {
	width: 100%; 
	padding-top: 0px;
	max-height: 500px;
	max-width: 400px;
	overflow-y: auto;
	z-index: var(--ks-z-search-bar, 4);
	position: fixed;
}
.ks-search-bar .ks-search-bar-results:empty {
	display: none;
}
</style>

